<template>
  <div>
    <h4>
      Register Devices
    </h4>
    <template v-if="!$store.state.admin.createResult">
      <div class="add-form">
        <div class="form-row">
          <span class="label">IMEI:</span>
          <span class="spacer"></span>
          <sui-input class="tbl-input imei" maxlength="15" v-model="imei" @keyup.enter.native="imeiEnterHandler" ref="fldIMEI" />
          <sui-checkbox class="radio" label="ev07s" radio value="ev07s" v-model="deviceType" />
          <sui-checkbox class="radio" label="ev07b" radio value="ev07b" v-model="deviceType" />
        </div>
        <!-- ICC -->
        <div class="form-row">
          <span class="label">ICC:</span>
          <sui-checkbox label="" v-model="includeSIMs" />&nbsp;&nbsp;
          <sui-input :disabled="!includeSIMs" class="tbl-input icc" maxlength="20" v-model="icc" @keyup.enter.native="iccEnterHandler" ref="fldICC" />
          <sui-checkbox class="radio" label="RiteSIM KPN" radio value="RITESIM" v-model="simProvider" />
          <sui-checkbox class="radio" label="RiteSIM EE" radio value="RITESIMEE" v-model="simProvider" />
          <sui-checkbox class="radio" label="BT EE" radio value="EE" v-model="simProvider" />
<!--          <span class="note">fill in this field if you are registering device with RITESIM Cards</span>-->

        </div>
        <!-- MSISDN -->
        <div class="form-row">
          <span class="label">MSISDN:</span>
          <sui-checkbox label="" v-model="includeMSISDN" />&nbsp;&nbsp;
          <sui-input :disabled="!includeMSISDN" class="tbl-input msisdn" maxlength="15" v-model="msisdn" @keyup.enter.native="msisdnEnterHandler" ref="fldMSISDN" />
          <span class="note">fill in this field if you want to manually assign phone number without SIM. Example: 447741234567</span>
        </div>
        <!-- Activation Code -->
        <div class="form-row">
          <span class="label">Activation Code:</span>
          <sui-checkbox label="" v-model="includeActivationCode" />&nbsp;&nbsp;
          <sui-input :disabled="!includeActivationCode" class="tbl-input activation-code" v-model="activationCode" @keyup.enter.native="addHandler" ref="fldActivationCode" />
          <span class="note">fill in this field if you do not want to auto-generate Activation Code</span>
        </div>
        <div class="form-row">
          <sui-button @click="addHandler">Add</sui-button>
        </div>

      </div>
    </template>
    <template v-if="deviceList.length > 0">
      <h4>Devices to Create</h4>
      <div class="add-list">
        <div class="add-list-header">
          <span class="list-item imei header">IMEI</span>
          <span class="list-item imei header">Type</span>
          <span class="list-item icc header">ICC</span>
          <span class="list-item icc header">Provider</span>
          <span class="list-item imei-check header">IMEI (from SIM)</span>
          <span class="list-item msisdn header">MSISDN</span>
<!--          <span class="list-item provider header">Provider</span>-->
          <span class="list-item provider header">Activation Code</span>
          <span class="list-item buttons header">&nbsp;</span>
        </div>
        <div class="add-list-item" v-for="(item, index) in deviceList" :key="item.IMEI">
          <span class="list-item imei">{{item.IMEI}}</span>
          <span class="list-item type type-ev07s" v-if="item.DeviceTypeID === 1">ev07s</span>
          <span class="list-item type type-ev07b" v-if="item.DeviceTypeID === 2">ev07b</span>
          <span class="list-item icc">{{item.ICC}}</span>
          <span class="list-item icc">{{item.Provider}}</span>
          <span class="list-item imei-check">
            {{item.SIMIMEI}}
            <span class="sticker orangered" v-if="(item.SIMIMEI || '') && trimIMEI(item.SIMIMEI) !== trimIMEI(item.IMEI)">mismatch</span>
          </span>
          <span class="list-item">{{item.MSISDN ? '+' + item.MSISDN : ''}}</span>
<!--          <span class="list-item">{{item.Provider}}</span>-->
          <span class="list-item">{{item.ActivationCode ? item.ActivationCode : 'auto-generate'}}</span>
          <span class="list-item buttons"><sui-icon name="delete" color="red" @click="deleteHandler(index)"/></span>
        </div>
      </div>

      <div class="register-form">
        <div class="form-row">
          <span class="label">Label(s):</span>
          <sui-dropdown class="tbl-input" multiple :options="[]" placeholder="Labels" icon="none" search selection allow-additions v-model="deviceLabels" />
          <span class="note">Stick custom text label to the devices - will be easier to identify later</span>
        </div>
        <div class="form-row">
          <sui-button primary @click="createDevicesHandler">Submit</sui-button>
        </div>

      </div>


    </template>
    <div v-if="$store.state.admin.createResult">
      <div class="add-list">
        <div class="add-list-header">
          <span class="list-item imei header">IMEI</span>
          <span class="list-item result header">Activation Code / Result</span>
        </div>
        <div class="add-list-item" v-for="(item) in $store.state.admin.createResult" :key="item.IMEI">
          <span class="list-item imei">{{item.IMEI}}</span>
          <span class="list-item result">
            <span class="error" v-if="item.Error">{{item.Error}}</span>
            <span v-else class="activation-code">{{item.ActivationCode}}</span>
          </span>
        </div>
      </div>
      <sui-message info>
        You can later find activation codes in List Devices Screen after clicking on the device
      </sui-message>
      <sui-button @click="resetForm">Reset Form</sui-button>
    </div>
  </div>
</template>

<script>
    export default {
      name: "DeviceManagementRegister",
      data: function() {
        return {
          nonBillable: false,
          imei: "",
          deviceType: "ev07b",
          icc: "",
          activationCode: "",
          msisdn: "",
          deviceList: [],
          includeSIMs: true,
          includeActivationCode: true,
          includeMSISDN: false,
          deviceLabels: [],
          simProvider: "EE",
        }
      },
      mounted: function() {
        if (this.$refs.fldIMEI) {
          this.$refs.fldIMEI.$el.children[0].focus();
        }
      },
      watch: {
        includeSIMs: function(newValue) {
          if (newValue) {
            this.includeMSISDN = false
            this.msisdn = ""
          }
          this.icc = ""
        },
        includeMSISDN: function(newValue) {
          if (newValue) {
            this.includeSIMs = false
            this.icc = ""
          }
          this.msisdn = ""
        },
        includeActivationCode: function() {
          this.activationCode = ""
        },
      },
      methods: {
        trimIMEI(imeiWithControlChar) {
          return (imeiWithControlChar || "").substr(0, 14)
        },
        imeiEnterHandler() {
          if (this.includeSIMs) {
            this.$refs.fldICC.$el.children[0].focus();
            return;
          }
          if (this.includeMSISDN) {
            this.$refs.fldMSISDN.$el.children[0].focus();
            return;
          }

          this.addHandler()
        },
        iccEnterHandler() {
          if (this.includeActivationCode) {
            this.$refs.fldActivationCode.$el.children[0].focus();
            return;
          }
          this.addHandler()
        },

        msisdnEnterHandler() {
          if (this.includeActivationCode) {
            this.$refs.fldActivationCode.$el.children[0].focus();
            return;
          }
          this.addHandler()
        },

        async addHandler() {
          // try to help with scanning right code
          if (this.includeSIMs && this.icc.trim().length < 19) {
            this.icc = ""
            return
          }
          if (this.includeActivationCode && this.activationCode.trim().length === 0) { return }
          if (this.imei.trim().length !== 15) { return }

          let sim = {}
          if (this.includeSIMs) {
            await this.$store.dispatch('admin/readSIM', {ICC: this.icc, SIMProvider: this.simProvider})
            if (!this.$store.state.admin.readSIMResponse) {
              return
            }
            sim = this.$store.state.admin.readSIMResponse
          }

          // Convert activation code - in case it has been provided as link (scan of the qr code)
          if (this.includeActivationCode) {
            this.activationCode = this.activationCode.replace("https://locaite.page.link/?apn=io.caite.locaite.app&ibi=io.caite.locaite.app&efr=1&isi=1479473645&link=https://register.caite.io/activation-code/", "")
          }
          let item = {
            IMEI: this.imei,
            DeviceTypeID: this.deviceType === 'ev07b' ? 2 : 1,
            ICC: sim.ICC,
            IMSI: sim.IMSI,
            MSISDN: sim.MSISDN || (this.msisdn || "").replace(/^\+/, ""),
            SIMIMEI: sim.IMEI,
            Provider: sim.Provider,
            ActivationCode: this.activationCode,
          }

          let prevalidateMsg = this.prevalidate(item)
          if (prevalidateMsg) {
            alert(prevalidateMsg)
            return
          }

          this.deviceList.push(item)
          this.imei = "";
          this.icc = "";
          this.msisdn = "";
          this.activationCode = "";
          this.$refs.fldIMEI.$el.children[0].focus();
        },

        deleteHandler(index) {
          this.deviceList.splice(index, 1)
        },
        async createDevicesHandler() {
          if (this.deviceList.length === 0) return
          this.deviceList.forEach((device) => {
            device.Labels = this.deviceLabels
          })
          await this.$store.dispatch('admin/createDevices', this.deviceList)
          this.deviceList = [];
          this.deviceLabels = [];
        },

        prevalidate(item) {
          let itemIMEI = item.IMEI
          let itemICC = item.ICC
          let itemActivationCode = item.activationCode
          let imeiMap = {}
          let iccMap = {}
          let activationCodeMap = {}
          for (let i = 0; i < (this.deviceList || []).length; i++) {
            let listItem = (this.deviceList)[i]
            imeiMap[listItem.IMEI] = listItem
            if (itemICC) iccMap[listItem.ICC] = listItem
            if (itemActivationCode) activationCodeMap[listItem.ActivationCode] = listItem
          }
          if (imeiMap[itemIMEI]) {
            return "there is already an item with imei " + itemIMEI
          }
          if (itemICC && iccMap[itemICC]) {
            return "there is already an item with icc " + itemICC
          }
          if (itemActivationCode && activationCodeMap[itemActivationCode]) {
            return "there is already an item with activation code " + itemActivationCode
          }
          return false
        },

        resetForm() {
          this.$store.commit('admin/setCreateResult', null)
          this.$nextTick(() => {
            this.$refs.fldIMEI.$el.children[0].focus();
          })
        }
      }
    }
</script>

<style scoped lang="less">
  .add-form, .register-form {
    margin: 5pt 0;
    vertical-align: middle;
    .form-row {
      margin: 10pt 5pt;
    }
    .label {
      display: inline-block;
      width: 100pt;
    }
    .radio {
      display: inline-block;
      margin-left: 20pt;
    }
    .spacer {
      display: inline-block;
      width: 22pt;
    }
    .note {
      color: darkolivegreen;
      display: inline-block;
      font-style: italic;
      &:before {
        content: "( "
      }
      &:after {
        content: " )"
      }
    }
    .tbl-input {
      margin-right: 10pt;
      &.imei {
        width: 115pt;
      }
      &.icc {
        width: 145pt;
      }
      &.msisdn {
        width: 115pt;
      }
      &.activation-code {
        width: 65pt;
      }
    }
  }
  .add-list {
    margin: 10pt 0pt;
    border-bottom: 1px solid #F0F0F0;
    .list-item {
      padding: 10pt;
      display: inline-block;
      width: 130pt;

      &.header {
        font-weight: bold;
        border-bottom: 1px solid #F0F0F0;
      }
      &.type {
        &.type-ev07s {

        }
        &.type-ev07b {
          color: blue;
        }
      }
      &.imei-check {
        width: 180pt;
      }
      &.provider {
        width: 100pt;
      }
      &.buttons {
        width: 40pt;
        text-align: right;
      }
      &.result {
        width: calc(100% - 130pt);
        .activation-code {
          color: darkgreen;
          font-weight: bold;
          display: inline-block;
        }
        .error {
          color: orangered;
        }
      }
    }
  }
</style>
